
$('.c-blob').each(function() {
  var $this        = $(this),
      $path        = $this.find('path'),
      blobWatcher = scrollMonitor.create($this),
      paths = [
        $path.attr('d'),
        $path.data('path'),
        $path.data('path2'),
      ];

  blobWatcher.enterViewport(function() {
    var timeline = anime.timeline({ autoplay: true, direction: 'alternate', loop: true });
    timeline.add({
      targets: 'path',
      d: {
        value: paths,
        duration: 4000,
        easing: 'easeInOutQuad'
      },
      offset: 0

    })
  });
});